import React from "react";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import Pricing from "../MenPricing/Pricing";
import Faq from "../MenAboutus/Faq";
import Download from "../Menhomeone/Download";
import Call from "../Menhomeone/Call";
import Footer from "../Global/Footer";
import GoToTop from "../Global/GoToTop";
const Main=()=>{
    return(

        <>
        <Preloader/>
        <Header/>
        <BredCrumb Title="Our Pricing" subtitle="Our Pricing" />
        <div className="page_wrapper">
          <Pricing/>
          <Faq/>
          <Download/>
          <Call/>
          <Footer/>
          <GoToTop/>

        </div>
       
        </>
    )
}
export default Main;